import { UtenteLogged } from "../authentication/authenticationSlice";

export const utenteFullName = (utente: UtenteLogged) => {
  // let isLogged = false;
  // Object.keys(utente).length !== 0 && (utente.isLogged = true);
  if (utente.first_name && utente.last_name) {
    return utente.first_name + " " + utente.last_name;
  }
  if (utente.first_name) {
    return utente.first_name;
  }
  if (utente.last_name) {
    return utente.last_name;
  }
  return utente.username;
};
